import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import DestinationPage from './components/DestinationPage';
import { Provider } from 'react-redux';
import store from './redux/store';

function App() {
  return (
    <div className="App">
      <Provider store={store} >
      <Header/>
      <DestinationPage/>
      </Provider>
    </div>
  );
}

export default App;
